import React from 'react';

function renderOECDTable(dataset) {
  const rows = [];
  function processData(data, prefix = '') {
    Object.entries(data).forEach(([key, value]) => {
      if (key === 'values') {
        Object.entries(value).forEach(([year, val]) => {
          rows.push(
            <tr key={prefix + year}>
              <td>{prefix}</td>
              <td>{val !== null ? val.toFixed(2) : 'N/A'}</td>
              <td>{year}</td>
            </tr>
          );
        });
      } else if (typeof value === 'object') {
        processData(value, prefix ? `${prefix} - ${key}` : key);
      }
    });
  }
  processData(dataset.data);
  return rows;
}

function OECDTable({ oecd }) {
  if (!oecd || Object.keys(oecd).length === 0) {
    return <p className="text-muted">No OECD data available for the selected industry and region</p>;
  }
  return (
    <section className="result-section mb-5">
      <div className="section-header">
        <h2>OECD Industry Statistics</h2>
      </div>
      <div className="result-container">
        {Object.entries(oecd).map(([datasetId, dataset]) => (
          <div className="dataset-section mb-4" key={datasetId}>
            <h3 className="dataset-title">{dataset.name}</h3>
            <p className="dataset-description">{dataset.description}</p>
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Indicator</th>
                    <th>Value</th>
                    <th>Year</th>
                  </tr>
                </thead>
                <tbody>
                  {renderOECDTable(dataset)}
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default OECDTable;
